import { mapActions, mapGetters, mapMutations } from 'vuex'
import { directive as onClickaway } from 'vue-clickaway'
import { getProductPriceTitle, resolveProductImage, routeToProduct } from '@/helpers'
import some from 'lodash/some'
import typeSelect from '@/components/group-product/components/select/index.vue'

export default {
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    currentProduct: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    typeSelect,
  },
  name: 'selectProduct',
  data() {
    return {
      selectedProduct: '',
      selectedCount: 1,
      openSelect: false,
      isProductPriceInBasket: false,
      selectedProductPrice: '',
      favoriteSelect: false,
      basketKey: 1,
      leftoverType: null,
    }
  },
  computed: {
    ...mapGetters({
      basket: 'basket/basket',
      showNotifyLoader: 'products/showNotifyLoader',
    }),
    setCurrentPrice() {
      return Number(Number(this.selectedProductPrice.price) * this.selectedCount).toFixed(2)
    },
  },
  watch: {
    basket: function () {
      this.basketKey += 1
      this.checkProductInBasket()
    },
  },
  created() {
    this.selectProductPrice(this.currentProduct.productPrices.data)
    this.isProductPriceInBasket = some(this.basket, { select_type: { id: this.selectedProductPrice.id } })
    this.basket.forEach((product) => {
      if (product.select_type.id === this.selectedProductPrice.id) {
        return (this.selectedCount = product.select_count)
      }
    })
  },
  methods: {
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      changeBasketPopup: 'popups/CHANGE_BASKET_POPUP',
      showNotifyWhenAvailable: 'popups/SHOW_NOTIFY_WHEN_AVAILABLE',
      changeSeminarDetailsPopup: 'popups/CHANGE_SEMINAR_DETAILS_POPUP',
    }),
    ...mapActions({
      fetchData: 'products/SET_PRODUCT_WHEN_AVAILABLE',
    }),

    getOptionTitle(item) {
      this.value = { title: item.title, price: item.price }
      this.selectedProduct = item
      return item.title
    },
    routeToProduct: routeToProduct,
    resolveProductImage: resolveProductImage,
    getProductPriceTitle,
    away: function () {
      this.openSelect = false
    },
    selectProductPrice(productPrice) {
      this.selectedProductPrice = productPrice[0]
    },
    changeCount(type, count = 1) {
      if (type === 'increment') {
        this.selectedCount += 1
      } else if (type === 'decrement') {
        this.selectedCount -= 1
      } else {
        if (count) {
          this.selectedCount = parseInt(count)
        }
      }
    },
    checkProductInBasket() {
      this.basketKey += 2
      this.isProductPriceInBasket = some(this.basket, { select_type: { id: this.selectedProductPrice.id } })
    },
    addBasket() {
      this.addToBasket({
        select_count: this.selectedCount,
        product_price: this.selectedProductPrice,
        product: this.currentProduct,
      })
      this.changeBasketPopup(true)
      this.checkProductInBasket()
    },
    showNotify() {
      const payload = {
        product_id: this.currentProduct.id,
        product_price_id: this.selectedProductPrice.id,
      }

      this.showNotifyPopup(payload)
    },
  },
}
